/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WhPerLiterLiquid } from './whPerLiterLiquid';


export interface StatusCodeValueWhPerLiterLiquid { 
    value?: WhPerLiterLiquid;
    status_code?: number;
}

